module.exports = __webpack_public_path__ + "static/clementine-4bd1e1154f99e3d9357d1b6e9456efba.svg";